import { useSelector } from 'react-redux';
import { getLanguages, getLanguage } from '../../state/login';

import {
    getAlertDefinitions,
    getEventTypes,
    getProviders,
} from '../../state/app/alerts';
import { getDiscoveryUIPreviewPane } from '../../pages/discovery/selectors';

export const useLanguages = () => useSelector(getLanguages);
export const usePane = () => useSelector(getDiscoveryUIPreviewPane);
export const useDefinitions = () => useSelector(getAlertDefinitions);
export const useEvents = () => useSelector(getEventTypes);
export const useProviders = () => useSelector(getProviders);
export const useLanguage = () => useSelector(getLanguage);
